import cx from 'classnames'
import Styles from 'components/StageActions/StageActions.module.scss'
import { CloseThick } from 'almanac-ui/icons'

export const CloseIcon = ({ className }: { className?: string }) => (
  <span className={cx(className, Styles.icon)}>
    <CloseThick />
  </span>
)
